import { RxCustomerAPI } from '@drifthq/dapper'

export const fetchGeolocation = () => {
  return RxCustomerAPI
    .get('/location')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => response)
}



// WEBPACK FOOTER //
// ./src/modules/geolocation/api.js